package io.horion.cv.models

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue

class EntryState(
    val id: String,
    val sectionId: String,
    title: String = "",
    resume: String = "",
    moisDebut: String = "",
    moisFin: String = "",
    anneeDebut: String = "",
    anneeFin: String = "",
    isOngoing: Boolean = false,
    description: String = ""
) {
    var title by mutableStateOf(title)
    var resume by mutableStateOf(resume)
    var moisDebut by mutableStateOf(moisDebut)
    var moisFin by mutableStateOf(moisFin)
    var anneeDebut by mutableStateOf(anneeDebut)
    var anneeFin by mutableStateOf(anneeFin)
    var isOngoing by mutableStateOf(isOngoing)
    var description by mutableStateOf(description)
}